// extracted by mini-css-extract-plugin
export default {"page-title":"styles_page-title__WO77V","layout":"styles_layout__5m7Hq","container":"styles_container__odkXP","pagination-container":"styles_pagination-container__Zcy5B"};